import React, { useState, useEffect } from 'react'
import styled from 'react-emotion'

const Container = styled('div')`
    position: relative;
    background-image: ${props => props.src ? `url(${props.src})` : 'unset'};
    background-size: cover;
    background-position: center;
    height: inherit;
    width: 100%;
`

const Fader = styled('div')`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-image: linear-gradient(180deg,rgba(9,42,94,0) 75%,rgba(9,42,94,.6) 100%);
`

const ProgressiveBackground = ({ src, imageParams, fade = false, ...props }) => {
    const qs = /\?/.test(src) ? '&' : '?'
    const initialImage = src + qs + "w=100"
    const finalImage = src + qs + imageParams

    const [currentImage, setCurrentImage] = useState(initialImage)

    useEffect(() => {
        let loadingImage = null
        const fetchImage = (src) => {
            const image = new Image()
            image.onload = () => setCurrentImage(loadingImage.src)
            image.src = src
            loadingImage = image
        }
        const cleanImage = () => {
            if (loadingImage) {
                loadingImage.onload = null
            }
        }
        fetchImage(finalImage)

        return cleanImage
    }, [src, imageParams])

    return (
        <Container src={currentImage} {...props}>
            {fade && <Fader />}
        </Container>
    )
}

export default ProgressiveBackground